import jQuery from "jquery";
window.$ = jQuery;

$(function () {
    function handleFooterBehavior(e) {
        if (e.matches) {
            // For viewports less than 768px
            $(".footer-container .footer-item.collapsible-xs").find(".menu-footer").attr("aria-hidden", "true").css("display", "none");

            $(document)
                .off("click.footerToggle")
                .on("click.footerToggle", ".footer-container .footer-item.collapsible-xs .title.btn", function () {
                    const $menu = $(this).closest(".footer-item.collapsible-xs").find(".menu-footer");
                    const isExpanded = $(this).attr("aria-expanded") === "false";
                    // console.log($(this).attr("aria-expanded"));

                    // console.log($(this).attr("aria-expanded", String(!isExpanded)));
                    $(this).attr("aria-expanded", isExpanded ? "true" : "false");
                    $menu.attr("aria-hidden", String(isExpanded)).css("display", isExpanded ? "none" : "block");
                });
        } else {
            // Remove the mobile-specific behavior for larger screens
            $(document).off("click.footerToggle");
            $(".footer-container .footer-item.collapsible-xs").find(".menu-footer").removeAttr("aria-hidden").css("display", "");
            $(".footer-container .footer-item.collapsible-xs .title.btn").removeAttr("aria-expanded");
        }
    }

    const mediaQuery = window.matchMedia("(max-width: 575px)");
    handleFooterBehavior(mediaQuery); // Initial check
    mediaQuery.addEventListener("change", handleFooterBehavior); // Listen for changes
});
